var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"type":_vm.type,"label":_vm.label},on:{"click":_vm.dadosForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }